import {Student} from '@esgi/contracts/esgi/types/esgi.students/endpoints/esgi.apigateway/teachers/storage/students/student';
import {Class} from '@esgi/contracts/esgi/types/esgi.students/endpoints/esgi.apigateway/teachers/storage/classes/class';


export class AddNewStudentViaFile {
	constructor(
		public studentsData: { students: Student[]; classId: Class['id'] }
	) {}
}